import Component from './InDmFrame.vue'
export default Component
export * from './types'
